module.exports = __webpack_public_path__ + "1.0.0-d5234419/img/offline-vault-4.ccb41fd3.svg";